<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "BrandSelectMultiple" });
import { SelectMultiple } from "../../../../selects/index.js";
import * as API from "../../services/api.js";
import { onMount } from "svelte";
export let keys;
export let verticalCodes = [];
export let verticalCode = void 0;
export let isDisabled = false;
export let minItems = 0;
export let maxItems = 5e3;
export let states = [];
export let label = "resource.brand.plural.label";
export let placeholder = "resource.brand.plural.placeholder";
export let whitelist = [];
const DEBOUNCE_TIMEOUT_MS = 500;
const MINIMUM_SEARCH_LENGTH = 1;
const LIMIT = 30;
const DIRECTION = "desc";
const ORDER_BY = "recommended";
let offset = 0;
let loadedBrands = [];
let isLoading = false;
let searchQuery = "";
let debounceTimeout;
let initialBrands = [];
let isDropdownOpen = false;
let parameters = {
    direction: DIRECTION,
    limit: LIMIT,
    offset,
    orderBy: ORDER_BY,
    states,
    verticalCodes
};
const format = (brands) => brands.map(({ name, _: meta }) => ({ key: meta.key, label: name }));
const mergeUniqueBrands = (NEW_BRANDS, EXISTING_BRANDS) => {
    const MERGED_KEYS = /* @__PURE__ */ new Set();
    const MERGED_LIST = [];
    for (const BRAND of [...NEW_BRANDS, ...EXISTING_BRANDS]) {
        const KEY = BRAND._.key;
        if (!MERGED_KEYS.has(KEY)) {
            MERGED_KEYS.add(KEY);
            MERGED_LIST.push(BRAND);
        }
    }
    return MERGED_LIST;
};
const loadMoreBrands = async () => {
    if (!isDropdownOpen || isLoading || parameters.offset > loadedBrands.length) {
        return;
    }
    isLoading = true;
    if (parameters.offset === 0) {
        parameters.offset += initialBrands.length;
    }
    const NEW_BRANDS = await API.filterBrands({ ...parameters, query: searchQuery });
    if (NEW_BRANDS.length > 0) {
        const FORMATTED_NEW_BRANDS = format(NEW_BRANDS);
        const EXISTING_BRAND_KEYS = new Set(loadedBrands.map((brand) => brand.key));
        const UNIQUE_BRAND_KEYS = FORMATTED_NEW_BRANDS.filter((brand) => !EXISTING_BRAND_KEYS.has(brand.key));
        loadedBrands = [...loadedBrands, ...UNIQUE_BRAND_KEYS];
        initialBrands = mergeUniqueBrands(initialBrands, NEW_BRANDS);
        parameters.offset += LIMIT;
    }
    if (isLoading) {
        isLoading = false;
    }
};
$: activeVerticalCodes = verticalCode === void 0 ? verticalCodes : [verticalCode];
const resetParameters = () => {
    offset = 0;
    loadedBrands = [];
    isLoading = false;
    parameters = {
        direction: DIRECTION,
        limit: LIMIT,
        offset,
        orderBy: ORDER_BY,
        states,
        verticalCodes: activeVerticalCodes
    };
};
const searchBrands = async (query) => {
    if (isLoading) {
        return;
    }
    isLoading = true;
    resetParameters();
    const SEARCHED_BRANDS = await API.filterBrands({ ...parameters, query });
    if (Array.isArray(SEARCHED_BRANDS)) {
        loadedBrands = format(SEARCHED_BRANDS);
    }
    initialBrands = mergeUniqueBrands(initialBrands, SEARCHED_BRANDS);
    if (isLoading) {
        isLoading = false;
    }
};
const onSearch = (query) => {
    clearTimeout(debounceTimeout);
    if (query === void 0 || query === "") {
        resetParameters();
        loadedBrands = format(initialBrands);
        return;
    }
    debounceTimeout = setTimeout(() => {
        void (async () => {
            if (query.length >= MINIMUM_SEARCH_LENGTH) {
                await searchBrands(query);
            }
        })();
    }, DEBOUNCE_TIMEOUT_MS);
};
$: onSearch(searchQuery);
$: parameters = {
    direction: DIRECTION,
    limit: LIMIT,
    offset,
    orderBy: ORDER_BY,
    states,
    verticalCodes: activeVerticalCodes
};
onMount(async () => {
    const FETCHED_INITIAL_BRANDS = await API.filterBrands({
        direction: DIRECTION,
        limit: LIMIT,
        offset,
        orderBy: ORDER_BY,
        states,
        verticalCodes: activeVerticalCodes
    });
    let selectedBrands = [];
    if (Array.isArray(keys)) {
        const RESULTS = await Promise.all(keys.map(async (key) => API.fetchBrand({ brandKey: key })));
        selectedBrands = RESULTS.filter((brand) => Boolean(brand));
    }
    initialBrands = mergeUniqueBrands(selectedBrands, FETCHED_INITIAL_BRANDS);
    loadedBrands = format(initialBrands);
    offset += LIMIT;
});
</script>

<SelectMultiple
    bind:keys = { keys }
    bind:query = { searchQuery }
    on:scrollThreshold = { loadMoreBrands }
    bind:showList={isDropdownOpen}
    name = "brand.keys"
    { label }
    { placeholder }
    { isDisabled }
    { minItems }
    { maxItems }
    { whitelist }
    options = { loadedBrands }
    showSortedList = { false }
/>